import { createSlice } from '@reduxjs/toolkit';
import SubscriptionInfoRepository from 'repositories/loanOfficer/SubscriptionInfoRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'subscriptionInfo',
  repository: SubscriptionInfoRepository,
  slices: ['loadSubscriptionInfo', 'updateSubscriptionInfo'],
});

const initialState = {
  ...restSlice.initialState,
};

const loanOfficerSubscriptionInfoSlice = createSlice({
  name: 'loanOfficerSubscriptionInfo',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default loanOfficerSubscriptionInfoSlice;
export const loanOfficerSubscriptionInfoReducer = loanOfficerSubscriptionInfoSlice.reducer;
export const loanOfficerSubscriptionInfoHooks = restSlice.hooks(
  loanOfficerSubscriptionInfoSlice,
  'loanOfficerSubscriptionInfoReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/loanOfficer/subscriptionInfoSlice.js